<template>
    <section class="flower-list" id="flower-list">
        <div class="container">
            <div class="row" v-if="!show_flower">
                <div class="col-12">
                    <div class="img-wrap">
                        <!-- <img src="../assets/not_show.png" alt=""> -->
                    </div>
                </div>
            </div>

            <div class="row flower-row" v-else>
                <div class="col-12">
                    <div class="title-wrap">
                        <h1>印花攻略</h1>
                        <p>活動期間：{{all_datas[0].duration}}</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-sm-6 col-12">
                    <div class="main-wrap">
                        <div class="img-wrap">
                            <img src="../assets/flower-logos/8100.jpg" alt="">
                        </div>


                        <div class="text-wrap">
                            <h3 class="brand-name">7/26-8/22期間限定</h3>
                            <p class="text1">全店單筆每滿800元</p>
                            <p class="text2">加贈印花<span>4</span>枚</p>
                            <div class="link-wrap">
                                <a style="opacity:0">查看詳情</a>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-4 col-sm-6 col-12">
                    <div class="main-wrap">
                        <div class="img-wrap">
                            <img src="../assets/flower-logos/0301HAPPY WEEKEND.jpg" alt="">
                        </div>


                        <div class="text-wrap">
                            <h3 class="brand-name">11/22~03/19每週六日</h3>
                            <p class="text1">全店單筆每滿600元</p>
                            <p class="text2">加贈印花<span>3</span>枚</p>
                            <div class="link-wrap">
                                <a style="opacity:0">查看詳情</a>
                            </div>
                        </div>
                    </div>
                </div>


                <div v-for="(data, id) in all_datas" class="col-lg-4 col-sm-6 col-12">
                    <router-link :to="{ name: 'flower-list-inner', params: { id: id }}">
                        <div :class="`flower${data.id} main-wrap`">
                            <div class="img-wrap">
                                <img :src="data.brand_img" alt="">
                            </div>


                            <div class="text-wrap">
                                <h3 class="brand-name">{{data.brand_name}}</h3>
                                <p class="text1" v-html="data.brand_text1"></p>
                                <p class="text2" v-html="addSpan(data.brand_text2)"></p>
                                <!-- <p class="text2">{{hasNumber(data.brand_text2)}}</p> -->
                                <div class="link-wrap">
                                    <a :href="`#/FlowerList/${id}`">查看詳情</a>
                                </div>

                            </div>
                        </div>
                    </router-link>
                </div>
                <div class="col-12">
                    <div class="download-wrap">
                        <!-- <a target="_blank" class="bd-btn" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a> -->
                        <a target="_blank" href="./src/assets/0306-0319印花清單.pdf" class="bd-btn download-flowerlist" @click="open_pdf">下載印花清單</a>
                    </div>
                </div>
            </div>
            <!-- <div class="row" v-else>
                <div class="col-12">
                    <div class="download-wrap">
                        <a target="_blank" class="bd-btn download-flowerlist" href="./src/assets/pxmart-printingList1123_sc9v2.pdf">下載印花清單</a>
                    </div>
                </div>
            </div> -->

        </div>
    </section>
</template>
<script>
//import first_img from "./src/assets/flower-logos/01豬事福利來.jpg";
import axios from 'axios';
export default {
    data(){
		return {
            //first_img,
			all_datas: "",
            json_src: './src/assets/json/flower-list.json',
            show_flower: true

		}
    },
    methods: {
		get_flower_datas() {
            axios.get(this.json_src).then((response) => {

                //console.log(response.data)
                this.all_datas = response.data;


                response.data.forEach((e)=>{
                    //console.log(e.id)
                    this.ga_func(".flower"+e.id, "首頁-"+e.ga_name+"-印花");
                });

            }, (error) => {
            	console.log(error)
            })
        },
        ga_func(class_name, name){
            $("body").on('click',class_name , function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        },
        trigger_click(id){
            $(`.flower${id}`)[0].click();
        },
        addSpan(myString) {
            //return /\d/.test(myString);
            let d = myString.match(/\d+/);
            //return myString.indexOf(firstDigit);
            let nString = myString.replace(d, '<span>'+d+'</span>');
            return nString;
        },
        open_pdf(){

        }
    },
    mounted(){
        this.get_flower_datas();


        //download-flowerlist
        this.ga_func(".download-flowerlist", "首頁-下載印花清單");
        console.log("flowerLi!!")





	}

}
</script>
<style lang="sass">
@import '../sass/global'

*
    //border: 1px solid
// @import "../sass/globasl.sass"

section.flower-list
    .flower-row
        background-image: url('../assets/grey-bg.jpg')
        background-size: 100%
        background-position: center 0
        a
            &:hover
                text-decoration: none

    .title-wrap
        margin-bottom: 70px
        background: black
        color: white
        margin-left: -15px
        margin-right: -15px
        font-weight: 300
        padding: 15px 0
        @media (max-width: 768px)
            margin-bottom: 50px
        h1
            text-align: center
            font-weight: 300
            margin-bottom: 3px
            letter-spacing: 2px
            font-size: 32px
        p
            text-align: center
            margin-bottom: 0
            font-size: 14px
            letter-spacing: 2px
    .main-wrap

        padding-top: 0
        background: white
        box-shadow: 0 1px 10px rgba(black ,0.1)
        margin-bottom: 30px
        transition: .3s
        cursor: pointer
        span
            font-size: 20px
        &:hover
            .text-wrap
                background: #333
            *
                color: white
            a
                color: white !important
            .text2
                span
                    background: white
                    color: black

        .img-wrap
            // margin-left: -20px
            // margin-right: -20px
            width: 100%
            background: white
            text-align: center
            padding-top: 20px
            padding-bottom: 20px
            img
                width: 100%
                margin: 0 auto
        .text-wrap
            padding: 20px
            cursor: pointer
            background-color: $red
            background-size: cover
            background-position: center center
            color: white
            transition: .3s
        h3
            font-size: 20px
            margin-bottom: 5px
            transition: .3s
        .text1
            font-weight: 300
        .text2
            span
                padding: 4px 10px
                margin: 0 5px
                display: inline-block
                border-radius: 5px
        p
            margin-bottom: 5px
            transition: .3s
        .link-wrap
            text-align: right
            height: 0
            margin-top: 10px
            margin-bottom: 20px
            a
                transition: .3s
                color: white
                font-weight: 300
                text-decoration: underline
    .download-wrap
        margin-top: 20px
        margin-bottom: 80px
        @media (max-width: 576px)
            margin-top: 0
            margin-bottom: 80px
        a
            &:hover
                color: white
    .not_show_title
        text-align: center
        font-size: 24px
    .img-wrap
        img
            width: 100%


</style>



// WEBPACK FOOTER //
// src/Index/FlowerList.vue